import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
//import css from './css.module.less';
import CountWords from '@/src/components/CountWords/CountWords';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import { get } from 'lodash';
import React from 'react';
import { RangePicker } from 'src/components/';
import { Form, Input } from 'src/components/Antd';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

const Item = Form.Item;

//const RangePicker = OriginalPicker.RangePicker;
const name = 'title';
const DetailPart = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    timeError,
    time,
    onTimeChange,
    isPrimary,
    textColor,
    backgroundColor,
    onBackgroundColorChange,
    onTextColorChange,
  } = props;
  return (
    <SectionWrapper
      title={getI18n('salesChannelPromotionTag.index.promotionTagDetails')}>
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                title={`${getI18n('salesChannelPromotionTag.index.tagTitle')}*`}
                rightPart={
                  <Item
                    shouldUpdate={(p, c) => {
                      const pV = get(p, name);
                      const cV = get(c, name);
                      return pV !== cV;
                    }}>
                    {({ getFieldValue }) => {
                      const word = getFieldValue(name);
                      const count = (word || '').length;
                      return <CountWords count={count} allCount={32} />;
                    }}
                  </Item>
                }>
                <Input
                  size='large'
                  maxLength={32}
                  formProps={{
                    name: name,
                    rules: [
                      {
                        required: true,
                        message: getI18n(
                          'salesChannelPromotionTag.index.pleasefillthetitle',
                        ),
                      },
                    ],
                  }}
                />
              </ItemWrapper>
            ),
          },
          {
            child: isPrimary ? (
              <ItemWrapper
                title={`${getI18n(
                  'salesChannelPromotionTag.index.activeTime',
                )}*`}>
                <RangePicker
                  id={`time-picker-promotion-tag`}
                  size='large'
                  error={{
                    hasError: timeError,
                    errorMsg: getI18n(
                      'salesChannelPromotionTag.index.pleaseselectactivetime',
                    ),
                  }}
                  value={time}
                  onChange={onTimeChange}
                  occupiedRanges={[]}
                />
              </ItemWrapper>
            ) : (
              <React.Fragment />
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: isPrimary ? (
              <ItemWrapper
                title={
                  <div>
                    {getI18n(
                      'salesChannelPromotionTag.index.promotionTagBackgroundColour',
                    )}
                    <span
                      className={css.restoreDefault}
                      onClick={() => onBackgroundColorChange('#CF0000')}>
                      {getI18n('salesChannelPromotionTag.index.restoreDefault')}
                    </span>
                  </div>
                }
                containerClassName={css.containerClassName}>
                <ColorPicker
                  onChange={onBackgroundColorChange}
                  color={backgroundColor}
                  // {...(multi ? {} : { options })}
                  multi
                />
              </ItemWrapper>
            ) : (
              <React.Fragment />
            ),
          },
          {
            child: isPrimary ? (
              <ItemWrapper
                title={
                  <div>
                    {getI18n(
                      'salesChannelPromotionTag.index.promotionTagTextColour',
                    )}{' '}
                    <span
                      className={css.restoreDefault}
                      onClick={() => onTextColorChange('#FFFFFF')}>
                      {getI18n('salesChannelPromotionTag.index.restoreDefault')}
                    </span>
                  </div>
                }
                containerClassName={css.containerClassName}>
                <ColorPicker
                  onChange={onTextColorChange}
                  color={textColor}
                  // {...(multi ? {} : { options })}
                  multi
                />
              </ItemWrapper>
            ) : (
              <React.Fragment />
            ),
          },
        ]}
      />
    </SectionWrapper>
  );
};
export default DetailPart;
